import { useNavigate } from 'react-router-dom';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { Button } from '@/components/ui/button';

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <AuthLayout showTestimonial={false}>
      <div className="w-full text-foreground">
        <div className="flex items-center justify-center mb-6">
          <div className="rounded-full bg-destructive/10 p-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6 text-destructive">
              <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"></path>
              <path d="m15 9-6 6"></path>
              <path d="m9 9 6 6"></path>
            </svg>
          </div>
        </div>
        
        <div className="mb-6 text-center">
          <h1 className="text-4xl font-light tracking-tight text-foreground text-center mb-2">Access Denied</h1>
          <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">
            You don&apos;t have permission to access this page
          </p>
        </div>
        
        <div className="flex flex-col gap-4 max-w-xs mx-auto">
          <Button
            onClick={() => navigate('/today')}
            className="w-full"
          >
            Return to Dashboard
          </Button>
          
          <Button
            type="button"
            variant="outline"
            onClick={() => navigate('/')}
            className="w-full"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 inline mr-1.5">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              <polyline points="9 22 9 12 15 12 15 22"></polyline>
            </svg>
            Back to Home
          </Button>
          
          <Button 
            onClick={() => navigate('/login')}
            variant="link"
            className="text-primary"
          >
            Back to Login
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-2 h-4 w-4 inline">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
} 